import React from "react";
import Grid from "@material-ui/core/Grid";
import { useTranslation, Trans } from "react-i18next";

import daniel from "../assets/icons/team/Daniel.png";
import johannes from "../assets/icons/team/Johannes.png";
import lucia from "../assets/icons/team/Lucia.png";
import sophia from "../assets/icons/team/Sophia.png";
import orgs from "../assets/icons/team/Orgs.png";

import participantsFile from "../assets/data/Participantes.pdf";

import { onDataLinkClick } from "../utilities";

import "./Team.css";

const Person = ({ noLink, name, affiliation, href, src }) => (
  <Grid item xs={6} sm={3}>
    <div>
      <section>
        <p>
          {name}
          <br />({affiliation})
        </p>
      </section>
      <div>
        {noLink ? (
          <img style={{ width: "100%", maxWidth: "200px" }} src={src} alt="" />
        ) : (
          <a href={href} rel="noopener noreferrer" target="_blank">
            <img
              className="clickable"
              style={{ width: "100%", maxWidth: "200px" }}
              src={src}
              alt=""
            />
          </a>
        )}
      </div>
    </div>
  </Grid>
);

function Team() {
  const { t } = useTranslation();
  return (
    <div>
      <Grid
        container
        direction="row"
        justifycontent="space-evenly"
        alignItems="flex-end"
        spacing={2}
      >
        <Person
          name={t("sophia")}
          affiliation={t("sophiaAff")}
          href={"https://www.sophiacooke.com"}
          src={sophia}
        />
        <Person
          name="Daniel Proaño"
          affiliation="FUNCAVID"
          href={"http://www.funcavid.org"}
          src={daniel}
        />
        <Person name="Lucia Norris" affiliation={t("luciaAff")} noLink src={lucia} />
        <Person name="Dr. Johannes Klein" affiliation={t("johannesAff")} noLink src={johannes} />
      </Grid>
      <p>
        <Trans i18nKey="contactChannels">
          Contact us on
          <a href="mailto:info@co-galapagos.org">info@co-galapagos.org</a>.
        </Trans>
      </p>
      <Trans i18nKey="thanksText">
        <button
          className="link"
          onClick={() => onDataLinkClick(participantsFile, "participants.pdf")}
        >
          here
        </button>
        .
      </Trans>
      <img style={{ width: "100%", maxWidth: "100%" }} src={orgs} alt="" />
    </div>
  );
}

export default Team;
